<template>
  <div>
    <swiper ref="mySwiper" :options="swiperOptions" @click-slide="openLightBox">
      <swiper-slide v-for="(o, index) in 7" :key="`index-${index}`">
        <img
          class="swiper-img"
          :src="require(`../assets/img/swiper/swiper_img_b0${o}.png`)"
          alt=""
        />
      </swiper-slide>
      <!-- <swiper-slide v-for="o in 3" :key="o">
        <img
          class="swiper-img"
          :src="require(`../assets/img/swiper/swiper-img-${o}.png`)"
          alt=""
        />
      </swiper-slide> -->
    </swiper>
    <div class="swiper-button-prev" slot="button-prev"></div>
    <div class="swiper-button-next" slot="button-next"></div>
    <LightBox :media="media" :showLightBox="false" ref="lightbox"></LightBox>
  </div>
</template>
<script>
import { Swiper, SwiperSlide, directive } from "vue-awesome-swiper";
import "swiper/css/swiper.css";
import LightBox from "vue-image-lightbox";
require("vue-image-lightbox/dist/vue-image-lightbox.min.css");

export default {
  data() {
    return {
      swiperOptions: {
        slidesPerView: 1,
        freeMode: false,
        spaceBetween: 10,
        navigation: {
          nextEl: ".swiper-button-next",
          prevEl: ".swiper-button-prev",
        },
        breakpoints: {
          992: {
            slidesPerView: "auto",
            freeMode: false,
            spaceBetween: 10,
            navigation: {
              nextEl: ".swiper-button-next",
              prevEl: ".swiper-button-prev",
            },
          },
        },
        // Some Swiper option/callback...
      },
      media: [
        {
          thumb: require("@/assets/img/swiper/swiper_img_b01.png"),
          src: require("@/assets/img/swiper/swiper_img_b01.png"),
        },
        {
          thumb: require("@/assets/img/swiper/swiper_img_b02.png"),
          src: require("@/assets/img/swiper/swiper_img_b02.png"),
        },
        {
          thumb: require("@/assets/img/swiper/swiper_img_b03.png"),
          src: require("@/assets/img/swiper/swiper_img_b03.png"),
        },
        {
          thumb: require("@/assets/img/swiper/swiper_img_b04.png"),
          src: require("@/assets/img/swiper/swiper_img_b04.png"),
        },
        {
          thumb: require("@/assets/img/swiper/swiper_img_b05.png"),
          src: require("@/assets/img/swiper/swiper_img_b05.png"),
        },
        {
          thumb: require("@/assets/img/swiper/swiper_img_b06.png"),
          src: require("@/assets/img/swiper/swiper_img_b06.png"),
        },
        {
          thumb: require("@/assets/img/swiper/swiper_img_b07.png"),
          src: require("@/assets/img/swiper/swiper_img_b07.png"),
        },
      ],
    };
  },
  computed: {
    swiper() {
      return this.$refs.mySwiper.$swiper;
    },
  },
  methods: {
    openLightBox(index) {
      console.log(index);
      this.$refs.lightbox.showImage(index);
    },
    slideClicked(index) {
      console.log(index);
    },
    getIndex(index) {
      console.log(index);
    },
  },
  created() {
    // vm = this;
  },
  mounted() {
    // console.log("Current Swiper instance object", this.swiper);
    // this.swiper.slideTo(3, 1000, false);
  },
  components: {
    Swiper,
    SwiperSlide,
    LightBox,
  },
  directives: {
    swiper: directive,
  },
};
</script>
<style lang="scss">
.swiper-container {
  width: vwX(1436);
  @include tablet {
    width: vw(600);
  }
  .swiper-wrapper {
    .swiper-slide {
      display: block;
      width: auto;
      height: vwX(497);
      @include tablet {
        height: vw(301);
        // width: vw(100);
      }
    }
  }
  .swiper-img {
    // min-height: vwX(497);
    height: 100%;
  }
}
.swiper-button-prev {
  left: vwX(180);
  top: 52%;
  @include tablet {
    left: vw(15);
    top: 75%;
  }
  &::after {
    color: white;
  }
}
.swiper-button-next {
  right: vwX(180);
  top: 52%;
  @include tablet {
    right: vw(10);
    top: 75%;
  }
  &::after {
    color: white;
  }
}
.vue-lb-thumbnail-wrapper,
.vue-lb-footer,
.vue-lb-arrow {
  display: none;
}
</style>